import React from "react";
import { Navigate, NavLink, Outlet } from "react-router-dom";
import { useAccess } from "@/lib/access";
import { UsersThree } from "@phosphor-icons/react";

// Admin-only settings. Each section is a nested route under /admin/settings;
// add new admin sections here.
export const SETTINGS_SECTIONS = [
  { to: "/admin/settings/users", label: "User Management", icon: UsersThree, testId: "settings-tab-users" },
];

export default function AdminSettings() {
  const { loading, roles } = useAccess();
  if (loading) return null;
  if (!roles.includes("admin")) return <Navigate to="/" replace />;

  return (
    <div data-testid="admin-settings-page">
      <div className="glass-header sticky top-0 z-10 px-8 pt-5">
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">Admin</div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Settings</h1>
        <div className="mt-4 flex items-center gap-1">
          {SETTINGS_SECTIONS.map(({ to, label, icon: Icon, testId }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testId}
              className={({ isActive }) =>
                "inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition " +
                (isActive ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-900")
              }
            >
              <Icon size={14} weight="bold" /> {label}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
}
